import api from '@/api';
import utilsActions from '@/utils/actions';

export default {
    namespaced: true,
    state: {
        list: [],
        error: null,
        errors: null,
        requestPending: false,
    },
    getters: {
        getById: (state) => (id) => state.list.find((item) => item.id === id),
    },
    mutations: {
        setList(state, list) {
            state.list = list;
        },
        clearError(state) {
            state.error = null;
        },
        setError(state, error) {
            state.error = error;
        },
        clearErrors(state) {
            state.errors = null;
        },
        setErrors(state, errors) {
            state.errors = errors;
        },
        startRequest(state) {
            state.requestPending = true;
        },
        endRequest(state) {
            state.requestPending = false;
        },
    },
    actions: {
        async list(context, countryId) {
            await utilsActions.defaultAction(context, api.regions.list(countryId), (data) => {
                context.commit('setList', data.data.regioncodes);
            });
        },
    },
};
